import React from 'react'

export default function JimCorbetIntro() {
  return (
    <>
       
       <section className='jimCorbetdeer-area'>
         <img src='/image/jimcorbett-deer-img.webp' className='img-responsive' alt='jim cobett' />
       </section>

      <section className='jimcorebetintro-area'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-8 col-md-9'>
              <span>Signature Moments Curated</span>
              <h4 className='heading'>The Resort</h4>
              <p>A refined retreat shaped by scenic beauty and quiet sophistication, offering spaces that invite you to unwind in effortless comfort while remaining gracefully connected to the world around you, creating an atmosphere where every moment feels unhurried, balanced, and beautifully restorative.</p>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}
